import type { Ref, TextareaHTMLAttributes } from "react";

import { control } from "./styles";

/**
 * A multi-line field, matching the single-line one.
 *
 * `resize-y` rather than the browser default of both axes: horizontal resizing
 * inside a flex column drags the whole layout around, and nobody has ever
 * wanted a wider textarea more than they wanted the page to stay still.
 */
export function Textarea({
  invalid = false,
  className = "",
  ref,
  ...rest
}: TextareaHTMLAttributes<HTMLTextAreaElement> & {
  invalid?: boolean;
  ref?: Ref<HTMLTextAreaElement>;
}) {
  return (
    <textarea
      ref={ref}
      className={control(invalid, `resize-y leading-relaxed ${className}`)}
      {...rest}
    />
  );
}
